import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./crm/routes/PrivateRoute";

import { Suspense } from "react";
import Loader from "./crm/components/atoms/Loader";

import DefaultLayout from "./crm/components/defaultLayout";
import Login from "./crm/views/Login";
import { ToastContainer } from "react-toastify";

function App() {
  const loading = <Loader />;

  return (
    <div className="App">
      <Suspense fallback={loading}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/*" element={<DefaultLayout />} />
          </Route>
        </Routes>
      </Suspense>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
    </div>
  );
}

export default App;
